import script from "./ProjectReports.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectReports.vue?vue&type=script&setup=true&lang=js"

import "./ProjectReports.vue?vue&type=style&index=0&id=48a1444f&lang=css"

const __exports__ = script;

export default __exports__